"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var initialHeaderViewState = {
    activeCharm: null,
};
exports.store = satcheljs_1.createStore('headerViewState', initialHeaderViewState)();
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/header/owa-header-store/lib/store/store.js
// module id = 370
// module chunks = 2 87 105 106 107